import * as tslib_1 from "tslib";
import loader from "@/components/loader.vue";
import { Action } from "vuex-class";
import { Vue, Component } from "vue-property-decorator";
let widget = class widget extends Vue {
    constructor() {
        super(...arguments);
        this.loading = false;
        this.deleteAccountDialog = false;
    }
    signout() {
        this.logout();
    }
};
tslib_1.__decorate([
    Action("auth/logout")
], widget.prototype, "logout", void 0);
widget = tslib_1.__decorate([
    Component({
        components: {
            loader,
            dialogDeleteAccount: () => import(/* webpackChunkName: "dialog-DeleteAccount" */ "@/dialogs/deleteAccount.vue")
        }
    })
], widget);
export default widget;
